module.exports = __webpack_public_path__ + "static/media/elkhorn_estuary_badge.843efec9.png";